export const FIRST_WELCOME_VOUCHER_VALUE = 300;
export const SECOND_WELCOME_VOUCHER_VALUE = 300;
